import React, { useState } from "react";
import { ListActionButtonProps, Aside } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { EditSystemForm } from "../edit-system-form/EditSystemForm";

export const EditSystemButton: React.FC<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <EditListButton onClick={openSidebar} disabled={false} />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                <EditSystemForm onSubmit={closeSidebar} onCancel={closeSidebar} itemToEditId={props.itemId} />
            </Aside>
        </>
    );
};
